/**
 * 工作台模块接口列表
 */
import {backendUrl, qydataUrl, geipUrl} from '@/assets/js/config'
import axios from '@/assets/plugins/axios'

export default {
  // 工作台企业数据看板项目数量查询
  queryProjectNum (params) {
    return axios.get(`${backendUrl}/workbench/ent/project/num`, params)
  },
  // 工作台员工面板项目数量查询
  queryEmployeeNum (params) {
    return axios.get(`${backendUrl}/workbench/employee/project/num`, params)
  },
  // 工作台员工面板查询各种未读消息数量
  queryMessageNum (params) {
    return axios.get(`${backendUrl}/workbench/employee/message-num`, params)
  },
  // 查询最近使用文件列表
  recentFile (params) {
    return axios.get(`${backendUrl}/workbench/employee/file/recent`, params)
  },
  // 查询最近参与项目列表
  recentProject (params) {
    return axios.get(`${backendUrl}/workbench/employee/project/recent`, params)
  },
  // 获取文件所在页数，及其所在页的数据(50条/页)
  getFileInfo (params) {
    return axios.get(`${backendUrl}/file/location`, params)
  },
  // 广材登录
  userIdLogin (params) {
    return axios.post(`${qydataUrl}/priceapi/login/userIdLogin?gldUserId=` + params.gldUserId)
  },
  // 广材-指标权益
  getUserInfoByGlobalId (params) {
    return axios.get(`${qydataUrl}/api/getUserInfoByGlobalId?globalId=` + params.gldUserId)
  },
  // 获取gldUserId
  getGldUserIdByToken () {
    return axios.get(`${geipUrl}/api/uaa/user`)
  },
  // 获取gldUserId
  getUserInfo () {
    return axios.get(`${backendUrl}/user/user_info`)
  }
}
